import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(${Colors.shade01Rgb});
  opacity: 0.4;
  z-index: 20;
`;

export const MainSection = styled.div`
  width: calc(100% - 74px);
`;
